import React from 'react'
import noImage from '../noImage.svg'

export default function NewsItem (props){


    let {title, description,urlToImage,url,source,publishedAt} = props
  
    return (
            
            <div className='my-3'>
            <div className="card"  >
                <img src={urlToImage ===  null ? {noImage} : urlToImage} className="card-img-top" alt="..."/>
                <div className="card-body">
                    <h5 className="card-title">{title}</h5>
                    <p className="card-text">{description}</p>
                    <a href={url} target='_blank' className="btn btn-sm btn-dark">Read More</a>
                </div>
                <div className="card-footer text-body-secondary">
                     By {source} on {new Date(publishedAt).toGMTString()}
                </div>
            </div> 
            </div>
 
    )
  
}
